
import IntroBanner from "@/components/intro-banner.vue";
import InfoRow from "@/components/info-row.vue";
import { defineComponent, inject, onMounted, reactive } from "vue";
import { useI18n } from "vue-i18n";
import ResearchCategoryFiltersData from "@/modules/research-category-filters-data";
import { location as contact } from "@/utils/default-data";

interface InfoCircle {
  title: string;
  entity: string;
  number: number;
}

interface InfoBanner {
  title: string;
  image: string;
}

export default defineComponent({
  components: {
    IntroBanner,
    InfoRow,
  },
  setup() {
    const { t } = useI18n();
    const keycloak = inject("keycloak") as Keycloak.KeycloakInstance;
    const { getResearchEquipmentCategories, loadResearchEquipmentCategories } =
      ResearchCategoryFiltersData();

    const CURRENT_RESEARCHER_COUNT = 1328;
    const CURRENT_RESEARCH_GROUP_COUNT = 111;

    const state = reactive({
      keyword: "",
      banner: {
        title: t("content.globalBannerTitle"),
        image: require("@/assets/images/bg-1.jpg"),
      } as InfoBanner,
      infoCircles: [] as Array<InfoCircle>,
      dialog: {
        login: false,
        register: false,
      },
    });

    const loadInfoCircleCounts = (data: any) => {
      state.infoCircles = [
        {
          title: t("content.globalResearchEquipmentTitle"),
          entity: "",
          number: data.equipmentCount,
        },
        {
          title: t("content.globalResearchEntitiesTitle"),
          entity: "",
          number: data.researchInfrastructureCount,
        },
        {
          title: t("content.globalResearcherUMTitle"),
          entity: "",
          number:
            data.userCount > CURRENT_RESEARCHER_COUNT
              ? data.userCount
              : CURRENT_RESEARCHER_COUNT,
        },
        {
          title: t("content.globalResearchTeamsTitle"),
          entity: "",
          number: 111,
        },
        {
          title: t("content.globalResearchProgramsTitle"),
          entity: "",
          number: 51,
        },
      ];
    };

    const onClickLogin = () => {
      keycloak.login({ redirectUri: location.href });
    };

    const onScroll = () => {
      var top = document.getElementById("info_circles")?.offsetTop;
      if (top) {
        if (top < window.pageYOffset + window.innerHeight) {
          for (let index = 0; index < state.infoCircles.length; index++) {
            const element = state.infoCircles[index];
            animateCircleValue(index, 0, element.number);
          }
          window.removeEventListener("scroll", onScroll);
        }
      }
    };

    onMounted(() => {
      loadResearchEquipmentCategories().then(() => {
        loadInfoCircleCounts(getResearchEquipmentCategories);
      });
      window.addEventListener("scroll", onScroll);
    });

    function animateCircleValue(
      index: number,
      initVal: number,
      lastVal: number
    ) {
      let startTime: number | null = null;
      let duration = 1500;

      const step = (currentTime: number) => {
        if (!startTime) {
          startTime = currentTime;
        }

        const progress = Math.min((currentTime - startTime) / duration, 1);

        state.infoCircles[index].number = Math.floor(
          progress * (lastVal - initVal) + initVal
        );

        if (progress < 1) {
          window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(window.requestAnimationFrame(step));
        }
      };
      window.requestAnimationFrame(step);
    }

    return {
      t,
      state,
      contact,
      getResearchEquipmentCategories,
      onClickLogin,
      onScroll,
      isAuthenticated: keycloak.authenticated,
    };
  },
});
